import './globalAnimations';
